import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.5 12c0-2.72 1.22-5.16 3.13-6.81A7.43 7.43 0 007.5 4.5C3.36 4.5 0 7.86 0 12c0 4.14 3.36 7.5 7.5 7.5 1.12 0 2.18-.25 3.13-.69A8.987 8.987 0 017.5 12z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.5 18.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5z"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.5 12c0-2.72 1.22-5.16 3.13-6.81A7.43 7.43 0 007.5 4.5C3.36 4.5 0 7.86 0 12c0 4.14 3.36 7.5 7.5 7.5 1.12 0 2.18-.25 3.13-.69A8.987 8.987 0 017.5 12z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.5 18.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5z"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15 24c0-5.44 2.44-10.32 6.26-13.62C19.36 9.5 17.24 9 15 9 6.72 9 0 15.72 0 24c0 8.28 6.72 15 15 15 2.24 0 4.36-.5 6.26-1.38C17.44 34.32 15 29.44 15 24z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M33 37.5c7.456 0 13.5-6.044 13.5-13.5S40.456 10.5 33 10.5 19.5 16.544 19.5 24 25.544 37.5 33 37.5z"
  }))
};
export var EffectActive = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});